import { useQuery } from "@tanstack/react-query";
import { getStates } from "../api";

export const useGetStates = () => {
  const { data, isLoading, isError, error, isSuccess, isFetching } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
  return { data, isLoading, isSuccess, isError, error, isFetching };
};